module.exports = __webpack_public_path__ + "static/img/photo-2.c55b9122.jpg";